// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'case';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.313 5.063H1.688c-.622 0-1.125.503-1.125 1.125v9c0 .62.503 1.124 1.125 1.124h14.624c.622 0 1.125-.503 1.125-1.125v-9c0-.62-.503-1.125-1.125-1.125z' />
    <path d='M12.375 5.063a3.375 3.375 0 0 0-6.75 0m-5.062 4.5h6.75m3.375 0h6.75m-10.125.75a1.687 1.687 0 1 0 3.375 0v-.9a1.687 1.687 0 1 0-3.376 0z' />
  </g>
);

export const viewBox = '0 0 18 18';
